import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideNewUserModal,
  setUsers,
  setInitialUsersData,
} from "../../redux-state/features/users";
import { showSuccess, showError } from "../../utils/index";
import axio from "axios";
import urls from "../../urls";
const NewUserForm = () => {
  const dispatch = useDispatch();
  // State for form fields
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [job, setJob] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  // Validate form inputs
  const validateForm = () => {
    const newErrors = {};

    if (!fullName.trim()) {
      newErrors.fullName = "الإسم الكامل مطلوب";
    }
    if (!email.trim()) {
      newErrors.email = "البريد الإلكتروني مطلوب";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "البريد الإلكتروني غير صالح";
    }
    if (!job) {
      newErrors.job = "الوظيفة مطلوبة";
    }
    if (!password.trim()) {
      newErrors.password = "كلمة المرور مطلوبة";
    } else if (password.length < 6) {
      newErrors.password = "كلمة المرور يجب أن تكون على الأقل 6 أحرف";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    console.log("faculty_id", faculty_id);
    if (validateForm()) {
      createNewAccount({ fullName, email, job, password, faculty_id });
    }
  };

  // Empty function for account creation
  const createNewAccount = (userData) => {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axio
      .post(urls.createNewUser, { ...userData, faculty_id })
      .then((res) => {
        dispatch(hideNewUserModal());
        const msg = ` تم إنشاء حساب المستخدم بنجاح `;
        showSuccess(msg);
      })
      .then(async (res) => {
        const users = await axio.get(urls.getUsers(faculty_id));

        dispatch(setUsers(users.data.results));
        dispatch(setInitialUsersData(users.data.results));
      })
      .catch((err) => {
        console.error(err);
        const msg = "لم يتم إنشاء الحساب بنجاح ";
        showError(msg);
      });

    // Add server-side logic here later
  };

  return (
    <div className="container mt-2">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <form onSubmit={handleSubmit} noValidate>
            {/* Full Name Field */}
            <div className="form-floating mb-3">
              <input
                type="text"
                className={`form-control ${
                  errors.fullName ? "is-invalid" : ""
                }`}
                id="fullName"
                placeholder="الإسم الكامل"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <label htmlFor="fullName">الإسم الكامل</label>
              {errors.fullName && (
                <div className="invalid-feedback">{errors.fullName}</div>
              )}
            </div>

            {/* Email Field */}
            <div className="form-floating mb-3">
              <input
                type="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                id="email"
                placeholder="البريد الإلكتروني"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="email">البريد الإلكتروني</label>
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            {/* Job Field */}
            <div className="form-floating mb-3">
              <select
                className={`form-select ${errors.job ? "is-invalid" : ""}`}
                id="job"
                value={job}
                onChange={(e) => setJob(e.target.value)}
              >
                {/* 'admin', 'store_manager', 'user', 'Inventory_officer', 'maintainer') */}
                <option value="">اختر الوظيفة</option>
                <option value="store_manager">مسيّر مخزن</option>
                <option value="user">مستخدم</option>
                <option value="Inventory_officer">مسيّر جرد </option>
                <option value="maintainer">مسؤول صيانة </option>
              </select>
              <label htmlFor="job">الوظيفة</label>
              {errors.job && (
                <div className="invalid-feedback">{errors.job}</div>
              )}
            </div>

            {/* Password Field */}
            <div className="form-floating mb-3">
              <input
                type="password"
                className={`form-control ${
                  errors.password ? "is-invalid" : ""
                }`}
                id="password"
                placeholder="كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label htmlFor="password">كلمة المرور</label>
              {errors.password && (
                <div className="invalid-feedback">{errors.password}</div>
              )}
            </div>

            {/* Submit Button */}
            <div className="d-grid">
              <button type="submit" className="btn btn-primary">
                تسجيل
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewUserForm;
